<template>
  <v-card class="center-block" max-width="700px" :loading="uploadLoading" flat>
    <v-card-text v-if="error" class="text-center red--text">{{ $t('api.commonError') }}</v-card-text>

    <div v-if="loading" class="loader-block">
      <Loader />
    </div>

    <div v-else>
      <div v-for="(item, index) in adminLineDatas" :key="index">
        <AdminLine :indexName="item.indexName" :name="item.name" />
      </div>
    </div>
  </v-card>
</template>

<script>
import AdminLine from '@/components/adminVideo/AdminLine'
import Loader from '@/components/Loader.vue'
import { mapState } from 'vuex'

export default {
  name: 'AdminLines',

  components: {
    AdminLine,
    Loader
  },

  computed: {
    ...mapState({
      loading: (state) => state.adminVideo.loading,
      uploadLoading: (state) => state.adminVideo.uploadLoading,
      error: (state) => state.adminVideo.error
    }),

    // Don't change indexName, this value is used for api endpoint.
    adminLineDatas() {
      return [
        {
          indexName: 'introduction',
          name: this.$t('adminVideo.labelVideoIntro')
        },
        {
          indexName: 'conclusion',
          name: this.$t('adminVideo.labelVideoOutro')
        },
        {
          indexName: 'audio',
          name: this.$t('adminVideo.labelAudio')
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
.loader-block
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
</style>
